import { Component } from '@angular/core';

@Component({
  selector: 'admin-horizontal-form-demo',
  templateUrl: './horizontal-form-demo.component.html',
  styleUrls: ['./horizontal-form-demo.component.scss'],
})
export class HorizontalFormDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/form/control/horizontal-form/horizontal-form-demo.component.ts